<template>
  <v-container
    id="dashboard"
    fluid
    grid-list-sm
    style="padding-right: 25px"
    tag="section"
  >
    <template v-if="data.length">
      <v-row>
        <v-col  cols="12" :lg="4" class="pt-0 pb-0 mb-1" v-for="item in data" >
          <v-card class="pa-2 text-center">
            <v-row>
              <v-col cols="6">
                <a @click="$router.push('/admin/candidate/report?department='+item.data.id+'&status=1')"><h1 style="font-size: 35px;color: green">{{item.count}}</h1></a>
                <p class="mb-0">Total accepted</p>
              </v-col>
              <v-col cols="6">
                <a @click="$router.push('/admin/candidate/report?department='+item.data.id+'&status=2')"><h1 style="font-size: 35px;color:red">{{item.count_pending}}</h1></a>
                <p class="mb-0">Total insufficient data/document</p>
              </v-col>
            </v-row>
            <p style="font-size: 16px;margin-bottom: 0px;color: darkblue">{{item.data.name}}</p>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row class="mb-1">
        <v-col  cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
        <v-col  cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
        <v-col cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
        <v-col cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mb-1">
        <v-col  cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
        <v-col  cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
        <v-col cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
        <v-col cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mb-1">
        <v-col  cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
        <v-col  cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
        <v-col cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
        <v-col cols="12" :lg="3" class="pt-0 pb-0" >
          <v-card>
            <vue-content-loading :width="300" :height="100">
              <rect x="20" y="10" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="30" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="50" rx="4" ry="4" width="250" height="5" />
              <rect x="20" y="70" rx="4" ry="4" width="250" height="5" />
            </vue-content-loading>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
  import VueContentLoading from 'vue-content-loading';
  export default {
    name: 'DashboardDashboard',
    components:{
      VueContentLoading
    },
    data () {
      return {
        data:[],
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData(){
        this.$Progress.start();
        this.$http.get('/api/dashboard/data',{headers:{'Authorization':'Bearer '+this.$store.state.token}})
          .then(response => {
            this.data=response.data;
            this.$Progress.finish()
          })
          .catch(e => {
            console.log("e",e)
            this.$Progress.fail()
          })
      },

    },
    mounted() {
    }
  }
</script>
